import { collection, query, where, doc, getDoc, getDocs, onSnapshot } from "firebase/firestore";

// export const getCollectionProducts = (db, selected_collection, store_products, callback, finalCallback) => {
//   const stockRef = collection(db, "products_stock");
//   const stockQuery = query(stockRef, where(`availableSizes.${selected_collection}`, "==", true));

//   return onSnapshot(stockQuery, async (stockSnapshot) => {
//     let totalCount = 0; // Contador total de productos
//     const allProducts = []; // Arreglo para almacenar todos los productos
//     const fetchPromises = []; // Arreglo para almacenar todas las promesas de fetch de datos de productos

//     for (const stockDoc of stockSnapshot.docs) {
//       const skus = stockDoc.data().skus;
//       const availableSizes = stockDoc.data().availableSizes;

//       const activeColors = new Set();
//       skus.forEach(sku => {
//         if (sku.related_options[1] === selected_collection && sku.qty > 0) {
//           activeColors.add(sku.related_options[0]);
//         }
//       });

//       const productsRef = collection(db, "products");
//       const productQuery = query(productsRef, where("product_inside_id", "==", stockDoc.id));
//       // Almacenar la promesa para esperar a que todas se completen más adelante
//       const fetchPromise = getDocs(productQuery).then(productSnapshot => {
//         const products = [];
//         for (const productDoc of productSnapshot.docs) {
//           const productData = productDoc.data();
//           const productOptions = productData.productOptions.map((option, index) => {
//             const optionIsActiveArray = option.values.map(value => {
//               if (index === 0) {
//                 return activeColors.has(value);
//               } else {
//                 return (availableSizes[value] && value === selected_collection) || false;
//               }
//             });
//             return { ...option, option_is_active: optionIsActiveArray };
//           });
//           // console.log("::::::: -> productOptions", productOptions)
//           products.push({ ...productData, productOptions });
//         }

//         allProducts.push(...products);
//         totalCount += products.length;
//         callback(totalCount); // Envía solo el conteo total actualizado
//       });

//       fetchPromises.push(fetchPromise);
//     }

//     // Espera a que todas las promesas de fetch se resuelvan antes de llamar a finalCallback
//     Promise.all(fetchPromises).then(() => {
//       finalCallback(allProducts); // Envía el arreglo completo al finalizar el procesamiento
//     });
//   });
// }

export const getProductsById = (db, store_products, onUpdate) => {
  // Almacenar las funciones de desuscripción para luego limpiar todo si se desea
  const unsubscribes = [];

  // Recorrer cada producto para suscribirte a su documento correspondiente
  store_products.forEach((productInfo) => {
    const { product_id_for_sell } = productInfo;

    // Referencia al documento "products/{product_id_for_sell}"
    const storeProdRef = doc(db, "products", product_id_for_sell);

    // Crear la suscripción en tiempo real
    const unsubscribe = onSnapshot(storeProdRef, (snapshot) => {
      if (snapshot.exists()) {
        // Llamamos al callback con la data del documento actualizado
        onUpdate({
          id: snapshot.id,
          ...snapshot.data(),
        });
      } else {
        // Si el documento no existe, puedes manejarlo como quieras
        onUpdate(null);
      }
    });

    // Agregar esta función de desuscripción al arreglo
    unsubscribes.push(unsubscribe);
  });

  // Devolvemos una función que, al ser llamada,
  // elimina todas las suscripciones onSnapshot
  return () => {
    unsubscribes.forEach((unsub) => {unsub()});
  };
};



export const getOnlyStockProduct = async (db, productData, selected_collection) => {
  // const stockRef = collection(db, "products_stock");
  // const stockQuery = query(stockRef, where("id", "==", productData.product_inside_id));
  // let stockDoc = null
  // let onSnapshotRemove = onSnapshot(stockQuery, async (stockSnapshot) => {
  //   console.log(stockSnapshot.docs)
  //   stockDoc = stockSnapshot.docs[0].data()
  // })
  // onSnapshotRemove()
  const stockRef = doc(db, "products_stock", productData.product_inside_id);
  const stockSnapshot = await getDoc(stockRef);
  const stockDoc = stockSnapshot.data()

  const skus = stockDoc.skus;
  const availableSizes = stockDoc.availableSizes;

  const activeColors = new Set();
  skus.forEach(sku => {
    if (sku.related_options[1] === selected_collection && sku.qty > 0) {
    // if (sku.qty > 0) {
      activeColors.add(sku.related_options[0]);
    }
  });

  const productOptions = productData.productOptions.map((option, index) => {
    const optionIsActiveArray = option.values.map(value => {
      if (index === 0) {
        return activeColors.has(value);
      } else {
        return (availableSizes[value] && value === selected_collection) || false;
        // return (availableSizes[value]) || false;
      }
    });
    return { ...option, option_is_active: optionIsActiveArray };
  });
  return { ...productData, productOptions };
}
